import cx from 'classnames'

import './style.scss'

type ListItemProps = {
  As?: any
  selected?: boolean
  onSelect?: () => void
  className?: string
  selectable?: boolean
  children: any
  [k: string]: any
}

export function ListItem({
  As = 'div',
  children,
  className,
  selectable = false,
  selected = false,
  leftAlign = false, // select radio button is on the left
  onSelect = () => {},
  ...props
}: ListItemProps) {
  return (
    <As
      className={cx(
        'List__item',
        selectable && 'List__item--selectable',
        className
      )}
      onClick={onSelect}
      {...props}
    >
      {!leftAlign && children}
      {selectable && (
        <svg
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          className={cx('radio', selected && 'radio--selected')}
        >
          <path
            d="M10.8836 0.833786C10.714 0.838909 10.5531 0.910776 10.4349 1.03416L3.71718 7.84691L1.56803 5.66734C1.40433 5.49443 1.16125 5.42478 0.932535 5.48525C0.70382 5.54572 0.525208 5.72686 0.465584 5.95881C0.40596 6.19076 0.474639 6.43728 0.645136 6.60329L3.25574 9.25082C3.51062 9.5092 3.92375 9.5092 4.17863 9.25082L11.3578 1.9701C11.5508 1.77982 11.6089 1.48887 11.5039 1.23746C11.399 0.986043 11.1527 0.825738 10.8836 0.833786Z"
            fill="currentColor"
          />
        </svg>
      )}
      {leftAlign && children}
    </As>
  )
}
